export default "__VITE_ASSET__DKAHy_1s__"